interface SongCardProps {
  cover: string;
  title: string;
  artist: string;
  showTitleInTop: boolean;
  onClick: () => {};
}

const SongCard = ({ cover, title, artist, showTitleInTop, onClick }: SongCardProps) => {
  return (
    <div
      onClick={onClick}
      className="bg-black/20 backdrop-blur-md rounded-xl overflow-hidden shadow-md"
    >
      {showTitleInTop ? (
        <div className="px-4 pt-2 pb-3 text-right">
          <p className="text-sm sm:text-base font-semibold sm:font-bold">{title}</p>
          <p className="text-sm text-white/80">{artist}</p>
        </div>
      ) : null}

      <img
        src={cover}
        alt={title}
        className="w-full aspect-[4/3] sm:aspect-auto object-cover rounded-md"
      />

      {!showTitleInTop ? (
        <div className="px-4 pt-2 pb-3 text-right">
          <p className="text-sm sm:text-base font-semibold sm:font-bold">{title}</p>
          <p className="text-sm text-white/80">{artist}</p>
        </div>
      ) : null}
    </div>
  );
};

export default SongCard;
